import { productFetch } from '../fetch';

import type { IPagingParams, ITableData } from '@/types';
import type { IProduct, IUsableAppendProduct, IProductCategory, IProductCollect } from './types';
export interface IOrderListParam {
  // 当前页码
  pageNo: number;
  pageNum: number;
  // 每页条数
  pageSize: number;
  // 订单号
  orderCode?: string;

  // 下单开始时间
  createTimeBegin?: string;
  // 下单结束时间
  createTimeEnd?: string;
  // 是否是一级账号
  parentStatus?: number;
  // 用户ID
  userId?: string;
  // 客户ID
  customerCodeList?: Array<string>;
  offset?: number;
  limit?: number;
}

/** 获取产品分类列表 */
export const fetchProductCategories = () =>
  productFetch.post<void, IProductCategory[]>('/productCatalog/selectAll');

/**
 * 产品列表接口
 * @param data
 */
export const fetchProductList = data =>
  productFetch.post<void, ITableData<IProduct>>('/product/baseinfo/getByPage', data);
/**
 * 查询库存
 */
export const queryProductTotalStock = data =>
  productFetch.post('/product/mall/queryProductTotalStock', data);
/**
 * 我的收藏夹列表
 * @param data
 * @returns
 */
// export const fetchFavoriteList = (data: IOrderListParam) =>
//   productFetch.post<void, void>('/collect/list', data);

/**
 * 根据产品id获取动态价格
 * @param data
 */
export const fetchProductPrice = id =>
  productFetch.post<void, ITableData<IProduct>>('/product/getProductPrice', id);

/**
 * 获取所有品牌
 */
export const fetchProductBrands = () => productFetch.post('/productBrand/getAll');

/**
 * 查询购物车是否存在加购的商品
 */
// export const fetchCheckExist = data => productFetch.post('/cart/checkExist', data);

/**
 * 加入商品到购物车
 */
export const fetchAddCartItem = data => productFetch.post('/cart/addCartItem', data);

/**
 *
 * @param data   相关产品
 * @returns
 */
export const fetchAllRelate = data => productFetch.post('/relatedProduct/product/getByPage', data);

/**查询主推品牌 */
export const fetchBrand = data => productFetch.post('/productBrand/mall/mainBrand', data);

/**所有品牌列表 */
export const fetchBrandAll = (data: any) => productFetch.post('/productBrand/getAll', data);

/**
 * 根据id查询商品基本信息
 */
export const getProductDetailId = data =>
  productFetch.post(`/product/baseinfo/getById?id=${data.id}`);

/**
 * 根据id查询关联商品信息
 */
export const getByProductId = data =>
  productFetch.post(`/relatedProduct/getByProductId?productId=${data.id}`);

/**按照推荐设置类别查询商品 */
export const queryProductByRecSettings = data =>
  productFetch.post('/product/queryProductByRecSettings', data);

/**获取知名品牌 */
export const fetchRecommendedBrand = data =>
  productFetch.post('/productBrand/mall/recommendedBrand', data);

/**获取品牌专区 */
export const fetchBrandZone = data => productFetch.post('/productBrand/mall/page', data);

// // 加入商品到购物车
// export const fetchAddCartItem = data => {
//   return fetch({
//     url: baseURL + '/cart/cart/addCartItem',
//     method: 'POST',
//     data,
//   });
// };

/**获取所有收藏 */
export const fetchCollects = (data: IPagingParams) =>
  productFetch.post<void, ITableData<IProductCollect>>('/collect/list', data);

/**加入收藏列表 */
export const addCollects = (data: any) => productFetch.post('/collect/add', data);

/**
 * 取消收藏
 * @param data
 * @returns
 */
export const collectsCancel = data => productFetch.post('/collect/cancel', data);
// productFetch.post<void, ITableData<IProductCollect>>('/collect/cancel', data);

/**获取可追加商品列表 */
export const fetchUsableAppendProducts = (
  data: IPagingParams &
    Partial<{
      name: IUsableAppendProduct['productName'];
      skuCode: IUsableAppendProduct['skuCode'];
      ifsSku: IUsableAppendProduct['ifsSku'];
      searchCustomerPrice: IUsableAppendProduct['searchCustomerPrice'];
    }>
) =>
  productFetch.post<void, ITableData<IUsableAppendProduct>>('product/cart/queryAddProduct', data);

/**获取热销产品 */
export const fetchHotSaleProducts = data =>
  productFetch.post('/product/queryProductByRecSettings', data);

// 手动添加商品

export const fetchAddProducts = data => productFetch.post('product/cart/queryAddProduct', data);

/**批量获取产品价格 */
export const fetchProductPrices = data =>
  productFetch.post('/product/batchQueryProductPrice', data);
